
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDiodes03 as ObiDiodes03Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-diodes-03.js';
 
 
 

 
 export const ObiDiodes03 = createComponent({
   react: React,
   tagName: 'obi-diodes-03',
   elementClass: ObiDiodes03Element,
   events: {
     
   }
  });
 
 